export const siteSettings = {
  name: "Alpha Helix Zone",
  link: "https://alphahelixzone.com",
  email: "support@alphahelixzone.com",
  appLink: "https://app.alphahelixzone.com",
};
